import axios from "axios";

let headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

const api = axios.create({
  baseURL: `${window.appConfig ? window.appConfig.apiRoot : process.env.VUE_APP_API_URL}`,
  withCredentials: false,
  headers: headers
});



export default api;
